import { Button, Col, Form, Input, message, Row, Select, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import {
  SearchOutlined,
  CaretDownFilled,
  PlusOutlined,
} from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import {
  DateRangeType,
  DateSelect,
    getDateRange,
    NotificationDateRangeTypes,
} from '../../../compnents/form/DateSelect'
import moment from 'moment'
import { DateTimeFormatMessageSimple } from '../../../models/datetime'
import { unwrapResult } from '@reduxjs/toolkit'
import { RootDispatch } from '../../../app/store'
import { NotificationCenterParams } from '../../../services/notificationCenter'
import { getMessageUserList } from './notificationCenterSlice'
const { Option } = Select

export const NotificationCenterQuery = (props: {
  onValueChange: (queries: NotificationCenterParams) => void
  add: (v?: any) => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [data, setData] = useState<any[]>([])

  const [userList, setUserList] = useState([])

  useEffect(() => {
    dispatch(getMessageUserList())
      .then(unwrapResult)
      .then((res: any) => {
        setUserList(res)
      })
  }, [])

  // 默认查询时间范围为本月
  useEffect(() => {
    const [head, tail] = getDateRange(DateRangeType.ThisMonth)
    form.setFieldsValue({
      timeHead: head,
      timeTail: tail,
    })
    form.submit()
  }, [])

  return (
    <Form
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      form={form}
      name='control-hooks'
      autoComplete='off'
      onFinish={(vs) => {
        const start = vs?.timeHead ? moment(vs?.timeHead) : null
        const end = vs?.timeTail ? moment(vs?.timeTail) : null
        // 查询时间范围最大一个月
        if (start && end && end.diff(start, 'days') > 30) {
          message.warning('查询时间范围不能超过一个月')
          return
        }
        props.onValueChange({
          current: 1,
          size: 10,
          ...vs,
          timeHead: null,
          timeTail: null,
          startTime: start ? start.format(DateTimeFormatMessageSimple) : null,
          endTime: end ? end.format(DateTimeFormatMessageSimple) : null,
        })
      }}
    >
      <Row
        style={{ marginBottom: 10, width: '100%', height: '42px' }}
        align='middle'
        justify='space-between'
      >
        <Space>
          <Form.Item name='name' noStyle>
            <Input
              size='middle'
              placeholder='输入通知内容/消息标题/机构名称'
              allowClear
              onChange={() => form.submit()}
              prefix={<SearchOutlined />}
              style={{ width: '300px' }}
            />
          </Form.Item>
          <Form.Item name='flag' noStyle>
            <Select
              defaultValue='1'
              placeholder='群发通知'
              onChange={() => form.submit()}
              style={{ width: '9rem' }}
            >
              <Option value='1'>群发通知</Option>
              <Option value='2'>指向通知</Option>
            </Select>
          </Form.Item>
          <Form.Item name='userId' noStyle>
            <Select
              placeholder='创建人'
              allowClear
              suffixIcon={<CaretDownFilled />}
              onChange={() => form.submit()}
              style={{ width: '9rem' }}
            >
              {userList?.map((v: any) => (
                <Option key={v?.id} value={v?.id}>
                  {v?.realname}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name='' noStyle>
            <DateSelect
              placeholder='时间范围'
              style={{ width: '9rem' }}
              onChange={() => form.submit()}
              options={NotificationDateRangeTypes}
              initialValue={DateRangeType.ThisMonth}
              labelPrefix=''
              namePrefix='time'
            />
          </Form.Item>
        </Space>
        <Space>
          <Button
            onClick={() => form.submit()}
            type='primary'
            style={{ marginRight: '10px' }}
          >
            查询
          </Button>
          <Button
            type='primary'
            icon={<PlusOutlined />}
            style={{ float: 'right' }}
            onClick={() => {
              props?.add()
            }}
          >
            新增通知
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
